import useTranslation from 'next-translate/useTranslation';
import { MouseEventHandler } from 'react';

import { Translate } from '@core/constant';
import { EButtonVariant } from '@core/type';

import { Button } from './Button';

export const ButtonCancel = ({
  onClick,
}: {
  onClick: MouseEventHandler<HTMLButtonElement>;
}): JSX.Element => {
  const { t } = useTranslation(Translate.common.BUTTON);

  return (
    <Button variant={EButtonVariant.OUTLINED} onClick={onClick}>
      {t('cancel.title')}
    </Button>
  );
};
